<template>
  <main class="embed-page">
    <button
      class="embed-button"
      type="button"
      data-ah-vto-button
      data-ah-vto-merchant-id="nutramap"
      data-ah-vto-product-id="ivy"
      data-ah-vto-product-name="Ivy"
      data-ah-vto-price="$312.00"
      :data-ah-vto-wig-image="wigImageUrl"
    >
      Virtual Try-On
    </button>

  </main>
</template>

<script>
import hairImage from '../assets/hair.png'

export default {
  name: 'EmbedTestPage',
  data() {
    return {
      wigImageUrl: ''
    };
  },
  async mounted() {
    this.wigImageUrl = new URL(hairImage, window.location.origin).href;
    await this.$nextTick();
    this.loadWidgetScript();
  },
  methods: {
    loadWidgetScript() {
      const existingScript = document.getElementById('ah-vto-widget-loader');

      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement('script');
      script.id = 'ah-vto-widget-loader';
      script.src = 'https://log-wig-project.vercel.app/embed/tryon-widget.js';
      script.async = true;
      script.dataset.merchantId = 'nutramap';
      document.body.appendChild(script);

    }
  }
};
</script>

<style scoped>
.embed-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.embed-button {
  padding: 14px 24px;
  border: none;
  border-radius: 999px;
  background: #111;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.embed-button:hover {
  background: #1f1f1f;
}
</style>
